export default __webpack_public_path__ + "static/media/MP5_6.840314d3.png";